import { Component, Input, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-manual-eval-questions-modal',
  templateUrl: './manual-eval-questions-modal.component.html',
  // styleUrls: ['./manual-eval-questions-modal.component.css']
})
export class ManualEvalQuestionsModalComponent {
  @Input() questionText: string;
  @Input() answerText: string;
  @Output() modalStatusChange: EventEmitter<boolean> = new EventEmitter<boolean>();


  @ViewChild("modalContent") modalContent: TemplateRef<any>;
  modalRef: any;
  modalAnswerText: string;
  isModalOpen: boolean = false;
  modalQuestionText: any;
  isAnswerText:boolean = false

  constructor(private modalService: NgbModal) {}

  ngAfterViewInit (): void {
    console.log("Inside the modal page", this.answerText);
    console.log("Inside the modal page Qt ", this.questionText);
    if(this.questionText){
      this.modalQuestionText = this.questionText;
      console.log("Modal Question text", this.modalQuestionText);
    }
    console.log("isAnswerText out",this.isAnswerText)
    if (this.answerText) {
      this.modalAnswerText = this.answerText;
      this.isAnswerText = true;
      console.log("isAnswerText inside",this.isAnswerText)
      console.log("Modal Answer text", this.modalAnswerText);
      console.log("this.modalContent", this.modalContent);
    }
    this.clickModal(this.modalContent);
  }

  clickModal(input) {
    this.modalRef = this.modalService.open(input);
  }

  closeModal() {
    if (this.modalRef) {
      console.log("3456",this.isModalOpen);
      this.modalRef.close();
      this.isModalOpen = false;
      this.modalStatusChange.emit(this.isModalOpen);
    }
    
  }
}



